document.querySelectorAll('.agency-testimonial-carousel').forEach(function (carousel) {
  var slides = Array.from(carousel.querySelectorAll('.agency-testimonial-carousel__slide'));
  if (slides.length < 2) return;

  var current = 0;

  function showSlide(index) {
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
  }

  setInterval(function () {
    current = (current + 1) % slides.length;
    showSlide(current);
  }, 5000);
});
